export default "__VITE_ASSET__DuZjAelt__"